import { render, staticRenderFns } from "./ManagerSalaryLine.vue?vue&type=template&id=d5123f9a&scoped=true&lang=html&"
import script from "./ManagerSalaryLine.vue?vue&type=script&lang=js&"
export * from "./ManagerSalaryLine.vue?vue&type=script&lang=js&"
import style0 from "./ManagerSalaryLine.vue?vue&type=style&index=0&id=d5123f9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5123f9a",
  null
  
)

export default component.exports